import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  JOB_PAYMENT_REQUESTS_REFRESH: createSagaAction('JOB_PAYMENT_REQUESTS_REFRESH'),

  JOB_PAYMENT_REQUEST_CREATE: createSagaAction('JOB_PAYMENT_REQUEST_CREATE'),
  JOB_PAYMENT_REQUEST_UPDATE: createSagaAction('JOB_PAYMENT_REQUEST_UPDATE'),
  JOB_PAYMENT_REQUEST_DELETE: createSagaAction('JOB_PAYMENT_REQUEST_DELETE'),

  UPLOAD_PAYMENT_REQUESTS_ATTACHMENT: createSagaAction('UPLOAD_PAYMENT_REQUESTS_ATTACHMENT'),
  GET_PAYMENT_REQUESTS_ATTACHMENTS: createSagaAction('GET_PAYMENT_REQUESTS_ATTACHMENTS'),
  UPDATE_PAYMENT_REQUESTS_ATTACHMENT_DESCRIPTION: createSagaAction(
    'UPDATE_PAYMENT_REQUESTS_ATTACHMENT_DESCRIPTION'
  ),
  DELETE_PAYMENT_REQUESTS_ATTACHMENT: createSagaAction('DELETE_PAYMENT_REQUESTS_ATTACHMENT'),

  GET_PAYMENT_REQUEST_BY_VENDOR_ID: createSagaAction('GET_PAYMENT_REQUEST_BY_VENDOR_ID'),

  // notes
  GET_PAYMENT_REQUEST_NOTE: createSagaAction('GET_PAYMENT_REQUEST_NOTE'),
  CREATE_PAYMENT_REQUEST_NOTE: createSagaAction('CREATE_PAYMENT_REQUEST_NOTE'),
  EDIT_PAYMENT_REQUEST_NOTE: createSagaAction('EDIT_PAYMENT_REQUEST_NOTE'),
  DELETE_PAYMENT_REQUEST_NOTE: createSagaAction('DELETE_PAYMENT_REQUEST_NOTE')
}

// Action Creators
export const actions = {
  jobPaymentRequestsRefresh: ({ jobId, assignedToId, fromDashboard, next }) => ({
    type: constants.JOB_PAYMENT_REQUESTS_REFRESH.ACTION,
    jobId,
    assignedToId,
    fromDashboard,
    next
  }),

  getPaymentRequestByVendorId: ({ vendorId }) => ({
    type: constants.GET_PAYMENT_REQUEST_BY_VENDOR_ID.ACTION,
    vendorId
  }),

  createJobPaymentRequest: ({
    created_by_id,
    updated_by_id,
    job_id,
    due_date,
    payment_type,
    payable_from,
    payable_to_id,
    description,
    amount
  }) => ({
    type: constants.JOB_PAYMENT_REQUEST_CREATE.ACTION,
    created_by_id,
    updated_by_id,
    job_id,
    due_date,
    payment_type,
    payable_from,
    payable_to_id,
    description,
    amount
  }),

  updateJobPaymentRequest: ({
    jobId,
    paymentRequestId,
    created_by_id_payment_request,
    userId,
    content
  }) => ({
    type: constants.JOB_PAYMENT_REQUEST_UPDATE.ACTION,
    jobId,
    paymentRequestId,
    created_by_id_payment_request,
    userId,
    content
  }),

  deleteJobPaymentRequest: ({ paymentRequestId, jobId }) => ({
    type: constants.JOB_PAYMENT_REQUEST_DELETE.ACTION,
    jobId,
    paymentRequestId
  }),

  // Attachment actions
  uploadPaymentRequestAttachment: ({ formData, paymentRequestId }) => ({
    type: constants.UPLOAD_PAYMENT_REQUESTS_ATTACHMENT.ACTION,
    formData,
    paymentRequestId
  }),

  getPaymentRequestAttachments: ({ paymentRequestId }) => ({
    type: constants.GET_PAYMENT_REQUESTS_ATTACHMENTS.ACTION,
    paymentRequestId
  }),

  updatePaymentRequestAttachmentDescription: ({
    attachmentId,
    paymentRequestId,
    description,
    userId
  }) => ({
    type: constants.UPDATE_PAYMENT_REQUESTS_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    paymentRequestId,
    description,
    userId
  }),

  deletePaymentRequestAttachment: ({ attachmentId, paymentRequestId }) => ({
    type: constants.DELETE_PAYMENT_REQUESTS_ATTACHMENT.ACTION,
    attachmentId,
    paymentRequestId
  }),
  // notes
  getPaymentRequestNote: ({ paymentRequestId }) => ({
    type: constants.GET_PAYMENT_REQUEST_NOTE.ACTION,
    paymentRequestId
  }),
  createPaymentRequestNote: ({ content, userId, paymentRequestId }) => ({
    type: constants.CREATE_PAYMENT_REQUEST_NOTE.ACTION,
    content,
    userId,
    paymentRequestId
  }),
  editPaymentRequestNote: ({ content, noteId, paymentRequestId }) => ({
    type: constants.EDIT_PAYMENT_REQUEST_NOTE.ACTION,
    content,
    noteId,
    paymentRequestId
  }),
  deletePaymentRequestNote: ({ noteId, paymentRequestId }) => ({
    type: constants.DELETE_PAYMENT_REQUEST_NOTE.ACTION,
    noteId,
    paymentRequestId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.JOB_PAYMENT_REQUESTS_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.JOB_PAYMENT_REQUESTS_REFRESH.SUCCESS:
      return {
        ...state,
        jobPaymentRequests: action.payload
      }
    case constants.JOB_PAYMENT_REQUESTS_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.JOB_PAYMENT_REQUEST_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_PAYMENT_REQUEST_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_PAYMENT_REQUEST_DELETE.SUCCESS:
      return {
        ...state
      }

    case constants.UPLOAD_PAYMENT_REQUESTS_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingAttachment: true }
    case constants.UPLOAD_PAYMENT_REQUESTS_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingAttachment: false
      }

    case constants.GET_PAYMENT_REQUESTS_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingAttachments: true }
    case constants.GET_PAYMENT_REQUESTS_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        jobPaymentRequestsAttachments: action.payload,
        loadingAttachments: false
      }

    case constants.UPDATE_PAYMENT_REQUESTS_ATTACHMENT_DESCRIPTION.SUCCESS:
      return {
        ...state
      }

    case constants.DELETE_PAYMENT_REQUESTS_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingAttachment: true }
    case constants.DELETE_PAYMENT_REQUESTS_ATTACHMENT.SUCCESS:
      return {
        ...state,
        deletingAttachment: false
      }

    case constants.GET_PAYMENT_REQUEST_BY_VENDOR_ID.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_PAYMENT_REQUEST_BY_VENDOR_ID.SUCCESS:
      return {
        ...state,
        paymentRequests: action.payload
      }

    // NOTES
    case constants.GET_PAYMENT_REQUEST_NOTE.SUCCESS:
      return { ...state, paymentRequestNotes: action.paymentRequestNotes }

    case constants.CREATE_PAYMENT_REQUEST_NOTE.ACTION:
      return { ...state }
    case constants.CREATE_PAYMENT_REQUEST_NOTE.SUCCESS:
      return {
        ...state
      }
    case constants.EDIT_PAYMENT_REQUEST_NOTE.ACTION:
      return { ...state }
    case constants.EDIT_PAYMENT_REQUEST_NOTE.SUCCESS:
      return {
        ...state
      }
    case constants.DELETE_PAYMENT_REQUEST_NOTE.ACTION:
      return { ...state }
    case constants.DELETE_PAYMENT_REQUEST_NOTE.SUCCESS:
      return {
        ...state
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobPaymentRequestActions.js